import { Component } from '@angular/core';
import { Injectable } from '@angular/core';
import { Message, MessageService } from 'primeng/api';

export interface TaskReminderToastPayload {
  taskName: string;
  patientName: string;
  scheduledTimeText: string;
  programTaskId?: number;
}

@Component({
  selector: 'toast-severity',
  templateUrl: './toast.component.html',
})

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private readonly messageService: MessageService){}

  showToast(severity: string, summary: string, detail: string): void {
    this.messageService.add({severity,summary,detail,life: 5000,sticky: false,});
  }

  showStickyInfoToast(summary: string, detail: string): void {
    this.messageService.add({
      severity: 'info',
      summary,
      detail,
      sticky: true,
      closable: true,
      id: `sticky-info-${Date.now()}`,
      styleClass: 'task-reminder-toast-shell',
      contentStyleClass: 'task-reminder-toast-content',
    });
  }

  showTaskReminderToast(payload: TaskReminderToastPayload): void {
    const lines: string[] = [
      'Your task is due in about 10 minutes.',
      'Task: ' + payload.taskName.trim() || '—',
      'Patient: ' + payload.patientName.trim() || '—',
      'Scheduled time: ' + payload.scheduledTimeText.trim() || '—',
    ];

    const id = `task-reminder-${payload.programTaskId ?? 'na'}-${Date.now()}`;

    const message: Message = {
      severity: 'info',
      summary: 'Task reminder',
      detail: lines.join('\n'),
      sticky: true,
      closable: true,
      id,
      styleClass: 'task-reminder-toast-shell',
      contentStyleClass: 'task-reminder-toast-content',
    };
    this.messageService.add(message);
  }

}
